import React from "react";

import { Grid } from "@mui/material";

import PaperText from "../../../helper-components/misc/PaperText";
import CustomButton from "../../../helper-components/input/CustomButton";

import { replacePlaceholdersWithObjValues } from "../../../helper-functions/shared/miscUtils";

import { getLanguage } from "../../../config/language/language";

/**
 * The most important stats about the app, with a search bar.
 *
 * If no data found, show error message instead.
 */
export default function Introduction(props) {
    const status = props.backend.programStatus;

    const isLoggedIn = props.user.isLoggedIn;

    const loggedInOverviewText = replacePlaceholdersWithObjValues(getLanguage().HOME_OVERVIEW_TEXT_1, status);
    const loggedOutOverviewText = replacePlaceholdersWithObjValues(getLanguage().HOME_OVERVIEW_NO_DATA_TEXT_1, status);

    return (
        <Grid container>
            {/* Logged in, and data available. */}
            {isLoggedIn && status && (
                <>
                    <Grid item xs={12} md={12}>
                        <PaperText value={loggedInOverviewText} />
                    </Grid>
                </>
            )}

            {/* Not logged in, but public data available. */}
            {!isLoggedIn && status && (
                <>
                    <Grid item xs={12} sm={7}>
                        <PaperText value={loggedOutOverviewText} />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                        <CustomButton title="Sign in" path="/signin" fullWidth size="small" className="button-large" />
                    </Grid>

                    <Grid item xs={12}>
                        <PaperText whiteSpace="pre-wrap" value={getLanguage().HOME_OVERVIEW_NO_DATA_TEXT_3} />
                    </Grid>
                </>
            )}

            {/* Absolutely no data available. */}
            {!isLoggedIn && !status && (
                <>
                    <Grid item xs={12} md={12}>
                        <PaperText center bold value={getLanguage().HOME_OVERVIEW_NO_DATA_TEXT_2} />
                        <CustomButton title="Sign in" path="/signin" fullWidth size="small" />
                    </Grid>
                </>
            )}
        </Grid>
    );
}
